import { Component, Input } from '@angular/core';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';

@Component({
  selector: 'app-parent-child-my-messages',
  templateUrl: './parent-child-my-messages.component.html',
  styleUrls: ['./parent-child-my-messages.component.scss']
})
export class ParentChildMyMessagesComponent {
  @Input() childMyMessageData: any;
  currentStudentUserId;
  isEdit = false;
  messageData: any;
  currentStudentProfileId;
  parentChildData: any;

  constructor(
    private draggableModalService: DraggableModalService
  ) { }

  /**
   *@ngdoc method
   *@name setPage
   *@methodOf security.component
   *@description
   * - This is a method, which is used to set current page
   */
  toggleComposeBox(resetJson) { 
    
    this.parentChildData = JSON.parse(localStorage.getItem('parentChildLocalData'));
    this.isEdit = resetJson.isEdit;
    this.messageData = resetJson.messageData;
    const header = this.isEdit ? `Reply to ${this.messageData.fromName}` : `Message from ${this.parentChildData.userparentname}`;
    const baseId = 'modal-coach-message';
    const id = `${baseId}-${this.isEdit ? 'reply' : 'new'}-${this.currentStudentUserId}`;
    const modal = this.draggableModalService.show({
      id,
      baseId,
      trayTitle: header,
      class: 'message-modal',
      initialState: {
        attachments: [],
        modalId: id,
        header: header,
        messageData: Object.assign({}, this.messageData),
        isEdit: this.isEdit,
        currentStudentUserId: this.currentStudentUserId,
        currentStudentProfileId: this.currentStudentProfileId
      }
    });
    if (this.isEdit) {
      modal.content.updateFormData();
    }
  }
}
